import { OrderManagementEndUserPermissions } from './order-management.end-users.permissions';
import { OrdersPermissions } from './order-management.orders.permissions';
import { OnStreetReservationsPermissions } from './order-management.end-users.on-street-reservations.permissions';
import { OrderPaymentsPermissions } from './order-management.orders.payments.permissions';

export class OrderManagementPermissions {
  static EndUsers = OrderManagementEndUserPermissions?.Permissions;
  static Orders = OrdersPermissions?.Permissions;
  static OnStreetReservations = OnStreetReservationsPermissions?.Permissions;
  static OrderPayments = OrderPaymentsPermissions?.Permissions;
}

export function getOrderManagementModuleName() {
  return 'OrderManagement';
}
